export const affiliateLandingStats = [
  { label: 'Comiss\u00e3o recorrente', value: 'At\u00e9 50%' },
  { label: 'Pagamentos totais', value: 'R$ 2M+' },
  { label: 'Dura\u00e7\u00e3o do cookie', value: '90 dias' },
  { label: 'Taxa de convers\u00e3o', value: 'Alta' },
]

export const affiliateLandingBenefits = [
  {
    key: 'comissao-recorrente',
    title: 'Comiss\u00e3o recorrente',
    description:
      'Receba comiss\u00f5es enquanto suas indica\u00e7\u00f5es permanecerem com assinaturas ativas, conforme as regras do programa.',
  },
  {
    key: 'estrutura-conversao',
    title: 'Estrutura de convers\u00e3o',
    description:
      'P\u00e1gina e materiais pensados para explicar o produto com clareza e facilitar a jornada do usu\u00e1rio.',
  },
  {
    key: 'pagamentos-pontuais',
    title: 'Pagamentos pontuais',
    description:
      'Calend\u00e1rio fixo de repasses e hist\u00f3rico de pagamentos no painel para acompanhamento.',
  },
  {
    key: 'dashboard-completo',
    title: 'Dashboard completo',
    description:
      'Acompanhe cliques, cadastros e comiss\u00f5es direto do painel de afiliado.',
  },
  {
    key: 'suporte-dedicado',
    title: 'Suporte dedicado',
    description:
      'Time pronto para ajudar com estrat\u00e9gias, criativos e d\u00favidas t\u00e9cnicas.',
  },
  {
    key: 'materiais-prontos',
    title: 'Materiais prontos',
    description:
      'Banners, criativos e textos prontos para usar nas suas campanhas.',
  },
]

export const affiliateLandingSteps = [
  {
    step: '01',
    title: 'Envie seu interesse',
    text: 'Preencha o formul\u00e1rio com seus dados e links das suas m\u00eddias.',
  },
  {
    step: '02',
    title: 'An\u00e1lise do time',
    text: 'Nosso time avalia o perfil e entra em contato por e-mail.',
  },
  {
    step: '03',
    title: 'Receba seu link \u00fanico',
    text: 'Aprovado, voc\u00ea recebe link de divulga\u00e7\u00e3o e materiais prontos.',
  },
  {
    step: '04',
    title: 'Monetize sua audi\u00eancia',
    text: 'Divulgue o Cripto Alert e acompanhe as comiss\u00f5es pelo painel.',
  },
]

export const affiliateLandingSimulator = [
  {
    label: 'Se voc\u00ea indicar 10 assinantes Pro',
    value: 'R$ 788,00/m\u00eas',
    helper: 'Exemplo com plano Pro e comiss\u00e3o recorrente.',
  },
  {
    label: 'Se voc\u00ea indicar 50 assinantes Pro',
    value: 'R$ 3.940,00/m\u00eas',
    helper: 'Valores ilustrativos para proje\u00e7\u00e3o de renda.',
  },
]

export const affiliateLandingFaq = [
  {
    q: 'Preciso pagar para participar do programa?',
    a: 'N\u00e3o. O cadastro de interesse \u00e9 gratuito e a aprova\u00e7\u00e3o depende apenas da an\u00e1lise do seu perfil.',
  },
  {
    q: 'Como recebo minhas comiss\u00f5es?',
    a: 'Os pagamentos s\u00e3o realizados em janelas fixas, usando os dados cadastrais informados no painel de afiliado.',
  },
  {
    q: 'Posso usar tr\u00e1fego pago?',
    a: 'Sim, desde que respeite as diretrizes de marca e as pol\u00edticas da plataforma onde anunciar.',
  },
  {
    q: 'Quanto tempo demora para ser aprovado?',
    a: 'Na maioria dos casos a an\u00e1lise ocorre em at\u00e9 2 dias \u00fateis ap\u00f3s o envio do seu interesse.',
  },
]

